/**
 * Feature flag for AND/OR filters (V2 filter system).
 *
 * This is a non-React utility that can be called from Redux thunks,
 * reducers, and other non-hook contexts. The Statsig flag value is
 * cached by the useRampFlagAndOrFilters hook, which should be called
 * in workspace components.
 */

let cachedAndOrFiltersEnabled = false;

/**
 * Set the cached Statsig flag value for AND/OR filters.
 * Called by useRampFlagAndOrFilters hook to make the value available
 * for synchronous access in thunks and utilities.
 */
export function setAndOrFiltersEnabled(value: boolean): void {
  cachedAndOrFiltersEnabled = value;
}

/**
 * Check if AND/OR filters feature is enabled.
 * Can be called from anywhere (thunks, hooks, utilities).
 */
export function isAndOrFiltersEnabled(): boolean {
  return cachedAndOrFiltersEnabled;
}
